<template>
  <div class="voting__header-btn-wrapper">
    <a-visibility :hide="true" :on="[$breakpoint.mobile, $breakpoint.tablet]">
      <a-header-vote-button class="voting__header-btn" />
    </a-visibility>
  </div>
</template>

<script>
import AHeaderVoteButton from 'sections/_voting/shared/AHeaderVoteButton'

export default {
  name: 'HeaderVotingButton',
  components: { AHeaderVoteButton }
}
</script>

<style lang="scss" scoped>
.voting__header-btn-wrapper {
  margin-left: auto;
  flex-shrink: 0;
}
</style>
